import { Text, Box, Button, TextArea } from "grommet";
import React, { useEffect } from "react";
import './Symptoms.css';
import PropertyDisplayField from "../../../MedicalEmergenciesMainScreen/common/PropertyField/PropertyDisplayField";
import { indexOf } from "lodash";
import { Close } from "grommet-icons";
import { useStore } from "../../../../../../../Hooks/useStore";
import { observer } from 'mobx-react';

const Symptoms = observer((props) => {
    const {rootStore} = useStore(); 
    const otherSymptomFun = (e) => {
        rootStore.emsStore.handleOtherSympInput(!rootStore.emsStore.getOtherSympInput);
    }

    const selectSymptomFun = (symp) => {
        rootStore.emsStore.handleSelectedSymptoms(symp);
    }

    return (
        <div>
            <h1 className="symptomHeading">Passenger Complaints and Observations</h1>
            <Box>
                <Text>
                    {
                        rootStore.emsStore.commonSymptompList.map((symptom, index) => {
                            return(
                                <span onClick={() => selectSymptomFun(symptom)} style={{backgroundColor: rootStore.emsStore.getSelectedSymptoms.includes(symptom) ? '#1FB5FC' : 'rgba(31, 181, 252, 0.1)', color: rootStore.emsStore.getSelectedSymptoms.includes(symptom) ? "#fff" : "#000"}} className="symptomChip">
                                    {symptom} {rootStore.emsStore.getSelectedSymptoms.includes(symptom) && <Close color='white' size='small' style={{height: 15, width: 25}} />}
                                </span>
                            )
                        })
                    }
                </Text>
                <Text style={{display: 'inline-block', width: "max-width"}} onClick={otherSymptomFun}>
                    <span style={{backgroundColor: rootStore.emsStore.getOtherSympInput ? '#1FB5FC' : 'rgba(31, 181, 252, 0.1)', color: rootStore.emsStore.getOtherSympInput ? "#fff" : "#000"}} className="symptomChip">
                        Others
                    </span>
                </Text>
            </Box>
            {
                rootStore.emsStore.getOtherSympInput &&
                <Box className="textArea">
                    <TextArea
                        placeholder="Type symptoms here"
                        resize={false}
                        value={rootStore.emsStore.getOtherSymp}
                        onChange={event => rootStore.emsStore.handleOtherSymptoms(event.target.value)}
                    />
                </Box>
            }
            
                <Button type="Back" primary label="Back" onClick={() => props.onBack()} color={"brand-1"} className="btn" />
                <Button type="Done" primary label="Done" onClick={() => {props.onDone( rootStore.emsStore.getSelectedSymptoms, rootStore.emsStore.getOtherSymp );}} color={"brand-1"} className="btn" />
      
        </div>
    )
});

export default Symptoms;